module.exports = __webpack_public_path__ + "img/320.e7ad4425.svg";